export default __webpack_public_path__ + "static/media/filmingo.6869f18f.jpg";